"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CacheStorage = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _api = require("@whitbread-eos/api");
var _config = _interopRequireDefault(require("next/config"));
var _CookieStorageClient = require("./CookieStorageClient");
var _CookieStorageServer = require("./CookieStorageServer");
var _RedisStorageClient = require("./RedisStorageClient");
var _RedisStorageServer = require("./RedisStorageServer");
var {
  publicRuntimeConfig = {}
} = (0, _config.default)() || {};
class CacheStorage {
  constructor(_ref) {
    var {
      featureToggles,
      req,
      res,
      redisMutation
    } = _ref;
    if (CacheStorage.clientSideRequest) {
      if (CacheStorage.useRedis && featureToggles[_api.FT_PI_BB_CCUI_SET_BASKET_DETAILS_REDIS] && redisMutation) {
        this.storage = new _RedisStorageClient.RedisStorageClient(redisMutation);
      } else {
        this.storage = new _CookieStorageClient.CookieStorageClient();
      }
    } else {
      if (CacheStorage.useRedis && featureToggles[_api.FT_PI_BB_CCUI_GET_BASKET_DETAILS_REDIS]) {
        return;
      } else if (req && res) {
        this.storage = new _CookieStorageServer.CookieStorageServer(req, res);
      }
    }
  }
  static create(_ref2) {
    return (0, _asyncToGenerator2.default)(function* () {
      var {
        req,
        res,
        redisMutation,
        featureToggles
      } = _ref2;
      var instance = new CacheStorage({
        featureToggles,
        req,
        res,
        redisMutation
      });
      if (CacheStorage.useRedis && !CacheStorage.clientSideRequest && featureToggles[_api.FT_PI_BB_CCUI_GET_BASKET_DETAILS_REDIS]) {
        instance.storage = yield _RedisStorageServer.RedisStorageServer.getInstance();
      }
      return instance;
    })();
  }
  setItem(key, value, additionalParams) {
    var _this = this;
    return (0, _asyncToGenerator2.default)(function* () {
      yield _this.storage.setItem(key, value, additionalParams);
    })();
  }
  getItem(key) {
    var _this2 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      return _this2.storage.getItem(key);
    })();
  }
  removeItem(key) {
    var _this3 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      yield _this3.storage.removeItem(key);
    })();
  }
}
exports.CacheStorage = CacheStorage;
(0, _defineProperty2.default)(CacheStorage, "useRedis", !!publicRuntimeConfig.NEXT_PUBLIC_REDIS_HOST && !!publicRuntimeConfig.NEXT_PUBLIC_REDIS_PORT);
(0, _defineProperty2.default)(CacheStorage, "clientSideRequest", typeof window !== 'undefined');